import { useLocation } from 'react-router-dom';
import { matchRoutes } from 'react-router';
import MainRoutes, { RouteMetaData } from 'routes/MainRoutes';
import useBasePath from './useBasePath';
import { useMemo } from 'react';

export function useRouteMeta(): RouteMetaData | undefined {
  const getBasePath = useBasePath();
  const basePath = getBasePath();

  const location = useLocation();
  const routesConfig = useMemo(() => MainRoutes(basePath), [basePath]);

  const matches = matchRoutes([routesConfig], location);
  const found = matches
    ?.slice()
    .reverse()
    .find((m) => (m.route as any).meta);
  return (found?.route as any)?.meta as RouteMetaData | undefined;
}
